import LazyRetry from "@components/common/LazyRetry";
import { lazy } from "react";

const AsyncPage = ({ module }) =>
  lazy(() => LazyRetry(() => import(`../../${module.replace(/^\/+/, "")}`), module.replace(/^\/+/, "")));

export default AsyncPage;
